import React from "react";

// Inline SVG logos keyed by provider id.
const ProviderLogo = ({ id }) => {
  if (id === "google.com" || id === "google") return (
    <img
      src={require("../../assets/images/google_logo.svg").default}
      alt="Google"
      className="h-5 w-5 flex-shrink-0"
    />
  );
  if (id === "microsoft.com") return (
    <svg className="h-5 w-5 flex-shrink-0" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.4 2H2v9.4h9.4V2z" fill="#F25022"/>
      <path d="M22 2h-9.4v9.4H22V2z" fill="#7FBA00"/>
      <path d="M11.4 12.6H2V22h9.4v-9.4z" fill="#00A4EF"/>
      <path d="M22 12.6h-9.4V22H22v-9.4z" fill="#FFB900"/>
    </svg>
  );
  if (id === "apple.com") return (
    <svg className="h-5 w-5 flex-shrink-0" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
      <path d="M16.05 2c.08 1.02-.28 2.03-.93 2.78-.65.75-1.67 1.33-2.7 1.25-.1-.98.3-2 .93-2.72.65-.76 1.7-1.33 2.7-1.31zM19.98 17.1c-.48 1.05-1.04 2-1.73 2.82-.96 1.13-1.97 2.25-3.47 2.28-1.46.03-1.94-.87-3.61-.86-1.68.01-2.19.89-3.67.86-1.47-.04-2.43-1.1-3.4-2.24C2.22 17.6 1.04 14.3 1.04 11.1c0-4.46 2.9-6.82 5.76-6.86 1.44-.03 2.8.97 3.68.97.88 0 2.52-1.2 4.26-1.02.72.03 2.77.29 4.07 2.2-.1.07-2.43 1.42-2.4 4.23.03 3.36 2.94 4.47 2.97 4.48-.03.08-.46 1.59-1.4 3z"/>
    </svg>
  );
  if (id === "github.com") return (
    <svg className="h-5 w-5 flex-shrink-0" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
      <path d="M12 2C6.477 2 2 6.477 2 12c0 4.42 2.865 8.166 6.839 9.489.5.092.682-.217.682-.482 0-.237-.008-.866-.013-1.7-2.782.603-3.369-1.342-3.369-1.342-.454-1.155-1.11-1.462-1.11-1.462-.908-.62.069-.608.069-.608 1.003.07 1.531 1.03 1.531 1.03.892 1.529 2.341 1.087 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.11-4.555-4.943 0-1.091.39-1.984 1.029-2.683-.103-.253-.446-1.27.098-2.647 0 0 .84-.269 2.75 1.025A9.578 9.578 0 0112 6.836a9.59 9.59 0 012.504.337c1.909-1.294 2.747-1.025 2.747-1.025.546 1.377.202 2.394.1 2.647.64.699 1.028 1.592 1.028 2.683 0 3.842-2.339 4.687-4.566 4.935.359.309.678.919.678 1.852 0 1.336-.012 2.415-.012 2.743 0 .267.18.578.688.48C19.138 20.163 22 16.418 22 12c0-5.523-4.477-10-10-10z"/>
    </svg>
  );
  // Generic SSO shield for OIDC / SAML / unknown providers
  return (
    <svg className="h-5 w-5 flex-shrink-0 text-ink-gray-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    </svg>
  );
};

/**
 * Renders SSO sign-in buttons — one circular icon per provider when ≤4 providers,
 * otherwise falls back to a compact row of icon circles.
 *
 * @param {{ providers: Array<{id: string, label: string, type: string}>, onSignIn: (providerId: string) => void }} props
 */
const OAuthButton = ({ providers = [], onSignIn }) => {
  if (!providers.length) return null;

  return (
    <div className="flex flex-row items-center justify-center gap-3 w-full max-w-80">
      {providers.map((provider) => (
        <button
          key={provider.id}
          type="button"
          title={provider.label}
          aria-label={`Sign in with ${provider.label}`}
          onClick={() => onSignIn(provider.id)}
          className="photon-button-secondary relative flex items-center justify-center w-12 h-12 rounded-full border shadow-sm hover:shadow-md transition-colors duration-150"
        >
          <ProviderLogo id={provider.id} />
        </button>
      ))}
    </div>
  );
};

export default OAuthButton;

